import React from "react"
import { useSync } from "main/pos/hooks/SyncHooks"

const PosBackgroundSync = () => {
  useSync(true)
  return <></>
}

export default PosBackgroundSync
